import React from 'react';
import styles from './Form.module.sass'
import PropTypes from 'prop-types';
import Button from "../Button";

Form.propTypes = {
    submitHandler: PropTypes.func.isRequired,
    submitButtonText: PropTypes.string.isRequired,
};

function Form(props) {
    return (
        <form onSubmit={props.submitHandler} className={styles.Form}>
            {props.children}
            <div className={styles.buttonArea}>
                <Button disabled={props.submitDisabled} type={'submit'} color="blue" size="medium"
                        text={props.submitButtonText}/>
            </div>
        </form>
    );
}

export default Form;